<template>
<v-app>
  <v-toolbar app color="primary">
    <img width="50" height="50" :src="logoURL" class="pa-1">
    <v-toolbar-title class="white--text">{{title}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-side-icon class="hidden-md-and-up white--text" @click="drawer.open = !drawer.open"></v-toolbar-side-icon>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn flat v-for="(item,index) in items" :key="index" class="white--text" @click="setSideMenu(item)">
        <v-icon class="ma-1">{{ item.icon }}</v-icon>
        {{item.title}}
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
  <v-navigation-drawer app :class="{'hidden-md-and-up primary 300-width-drawer': drawer.open,'zero-width-drawer': !drawer.open}" temporary primary absolute right v-model="drawer.open">
    <v-list dense class="pa-0">
      <v-list-tile class="tile pointer white--text pa-2" :class="{'active': selectedItem === item.title}" v-for="(item,index) in items" :key="index" @click="setSideMenu(item)">
        <v-list-tile-action>
          <v-icon class="white--text">{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="subheading">{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
  <v-content>
    <Home id="home" />
    <About id="about" />
    <Services id="services" />
    <Events id="events" />
    <Contact id="contact" />
    <CopyRight />
  </v-content>
</v-app>
</template>

<script>
import $ from 'jquery'
import Home from './components/Home'
import About from './components/About'
import Services from './components/Services'
import Events from './components/Events'
import Contact from './components/Contact'
import CopyRight from './components/CopyRight'

import logo from '@/assets/images/karaoke.png'

export default {
  name: 'App',
  components: {
    About,
    Contact,
    Events,
    CopyRight,
    Home,
    Services
  },
  data() {
    return {
      drawer: {
        open: false
      },
      logoURL: logo,
      selectedItem: '',
      title: 'Saritha Sangeetham',
      items: [{
          title: 'Home',
          icon: 'home'
        },
        {
          title: 'About us',
          icon: 'info'
        },
        {
          title: 'Services',
          icon: 'audiotrack'
        },
        {
          title: 'Events',
          icon: 'mic'
        },
        {
          title: 'Contact',
          icon: 'contact_support'
        }
      ]
    }
  },
  methods: {
    setSideMenu(item) {
      const topOffset = 40
      console.log(`Selected Item: ${item.title}`)
      this.selectedItem = item.title
      $('html,body').animate({
        scrollTop: $(`#${this.getId(item.title)}`).offset().top - topOffset
      }, 1000)
      this.drawer.open = false
    },
    getId(title) {
      let id = 'home'
      switch (title) {
        case 'About us':
          id = 'about'
          break
        default:
          id = title.toLowerCase()
          break
      }
      return id
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/_colors.scss';

#app {
    font-family: 'Raleway', sans-serif;
}

.v-toolbar__title {
    font-family: 'Srisakdi', cursive;
    font-weight: bolder;
}

.v-navigation-drawer {
    position: fixed;
    overflow-y: scroll;
}

.tile {
    background: $primary;
    &:hover {
        background: $primaryLight;
    }
}

.active {
    background: $primaryDark;
}

.zero-width-drawer {
    width: 0 !important;
}

.300-width-drawer {
    width: 300px !important;
    height: 100% !important;
}
</style>
